import {$, w} from './constants';
 $(document).on('click', '.show_live_video', function(e){
    e.preventDefault();
    var $section = $(this).closest('.home__hero');
    var $playerWrap = $section.find('.yt-player-wrap');
    var $player = $section.find('.yt-player');
    var $bg = $section.find('.yt-bg');

    // 1) Detener el background (opcional, ahorra CPU)
    if ($bg.length) {
      var blank = ''; // dejar src vacío detiene el iframe
      $bg.attr('src', blank);
    }

    // 2) Cargar el player con controles (el click de usuario permite autoplay con sonido)
    var src = $player.data('src');
    if (src && !$player.attr('src')) {
      $player.attr('src', src);
    }

    // 3) Alternar estados visuales
    $section.addClass('is-live');
    $playerWrap.removeAttr('hidden');
  });